import { useState, useEffect, useMemo } from 'react'
import { trackTypesAPI } from '../services/api'

// The registry only changes with deploys, so one fetch per page load is
// shared by every component that asks for it.
let typesPromise = null

export function loadTrackTypes() {
  if (!typesPromise) {
    typesPromise = trackTypesAPI.getAll().catch((err) => {
      typesPromise = null
      throw err
    })
  }
  return typesPromise
}

/**
 * Presentation defaults for a registry type entry (safe on undefined).
 * Mirrors data-service TrackTypeRegistry.getPresentationDefaults.
 */
export function getTypeDefaults(type) {
  return {
    icon: type?.presentation?.defaultIcon || 'compass',
    label: type?.presentation?.defaultLabel || type?.label || type?.code || '',
  }
}

/**
 * Track-type registry from GET /api/track-types.
 *
 * Each entry: { code, label, description, agendaEligible,
 * singletonPerIntervention, configComponent,
 * presentation: { defaultIcon, defaultTone, defaultLabel, extensions } }.
 */
export function useTrackTypes() {
  const [types, setTypes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    loadTrackTypes()
      .then((data) => {
        if (!cancelled) setTypes(Array.isArray(data) ? data : [])
      })
      .catch((err) => {
        console.error('Error loading track types:', err)
        if (!cancelled) setError('Failed to load pathway types')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const typesByCode = useMemo(
    () => Object.fromEntries(types.map((type) => [type.code, type])),
    [types],
  )

  return { types, typesByCode, loading, error }
}

export default useTrackTypes
